var _style, _defs, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGtLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsa: "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    x: "0px",
    y: "0px",
    width: "914.8px",
    height: "170.3px",
    viewBox: "0 0 914.8 170.3",
    style: {
      enableBackground: "new 0 0 914.8 170.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svg-icon-logo .st0{fill:#231F20;}\n\t.svg-icon-logo .st1{fill:url(#SVGID_1_);}\n\t.svg-icon-logo .st2{fill:url(#SVGID_2_);}\n\t.svg-icon-logo .st3{fill:url(#SVGID_3_);}\n\t.svg-icon-logo .st4{fill:url(#SVGID_4_);}\n\t.svg-icon-logo .st5{fill:url(#SVGID_5_);}\n\t.svg-icon-logo .st6{fill:url(#SVGID_6_);}\n\t.svg-icon-logo .st7{fill:url(#SVGID_7_);}\n\t.svg-icon-logo .st8{fill:url(#SVGID_8_);}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "svg-icon-logo",
    className: "svg-icon-logo"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355,120.4c-8.4,0-11.5-3.7-11.5-9.6c0-6.8,3.8-10.3,13.7-10.3h13.1v3.9C370.3,114.8,363.9,120.4,355,120.4z  M332.2,111.9c0,8.1,4.7,16.8,19.4,16.8c8.5,0,14.4-3.3,18.5-8.5l1.4,7.2h9.2V88.6c0-16.6-9.9-19.5-21.7-19.5 c-8.9,0-20.6,2.6-23.4,16h11.3c1.4-5,4.8-7.9,12-7.9c5.9,0,11.5,2.1,11.5,11.5v4.1H358C342.9,92.8,332.2,97.8,332.2,111.9 L332.2,111.9z M302.2,127.4h10.6V91.8c0-8.3,5.1-12,11.6-12c2.2,0,4.5,0.1,6.8,0.5V70c-2-0.7-3.8-0.8-5.6-0.8 c-5.9,0-10.5,3.5-12.8,8.4l-1.3-6.9h-9.3L302.2,127.4L302.2,127.4z M678.2,127.4h10.6V91.8c0-8.3,5.1-12,11.6-12 c2.2,0,4.5,0.1,6.8,0.5V70c-2-0.7-3.8-0.8-5.6-0.8c-5.9,0-10.5,3.5-12.8,8.4l-1.3-6.9h-9.3V127.4z M478.9,79.8v-9.3h-11.6V54.3 L456.4,56v14.5h-8.2v9.3h8.2v36.1c0,8.1,3,13,14.9,13c2.6,0,6.5-0.5,8.9-1.2v-8.1c-2.5,0.7-4.8,0.8-6.5,0.8c-5,0-6.4-2.4-6.4-7.6 v-33H478.9z M798.8,79.8v-9.3h-11.7V54.3L776.2,56v14.5H768v9.3h8.2v36.1c0,8.1,3,13,14.9,13c2.6,0,6.5-0.5,8.9-1.2v-8.1 c-2.5,0.7-4.8,0.8-6.5,0.8c-5,0-6.4-2.4-6.4-7.6v-33H798.8z M640.8,120c-10.2,0-16.8-7.1-16.8-21.2c0-13.5,6.8-21.1,16.9-21.1 c10.2,0,16.2,7.5,16.2,21.7C657.1,113.2,650.9,120,640.8,120L640.8,120z M830.4,120c-10.2,0-16.8-7.1-16.8-21.2 c0-13.5,6.8-21.1,16.9-21.1c10.2,0,16.2,7.5,16.2,21.7C846.8,113.2,840.5,120,830.4,120L830.4,120z M714.6,127.4H725V94.6 c0-9.4,4.1-16,13.9-16c9.2,0,12,3.9,12,13.5v35.2h10.6V89.1c0-13.1-5.5-19.9-17.9-19.9c-8.5,0-14.8,3.1-18.6,8.5l-1.3-7.2h-9v56.9 H714.6z M394.4,127.4h10.3V94.6c0-9.4,4.1-16,13.9-16c9.2,0,12,3.9,12,13.5v35.2h10.6V89.1c0-13.1-5.5-19.9-17.9-19.9 c-8.5,0-14.8,3.1-18.6,8.5l-1.3-7.2h-9L394.4,127.4L394.4,127.4z M868,127.4h10.3V94.6c0-9.4,4.1-16,13.9-16c9.2,0,12,3.9,12,13.5 v35.2h10.6V89.1c0-13.1-5.5-19.9-17.9-19.9c-8.5,0-14.8,3.1-18.6,8.5l-1.3-7.2h-9V127.4z M551.4,51v-9.2h-60.5V51h24.7v76.3H527 V51H551.4z M556.9,127.4h10.3V94.6c0-9.4,4-16,13.9-16c9.2,0,12,3.9,12,13.5v35.2h10.6V89.1c0-13.1-5.5-19.9-17.9-19.9 c-8.5,0-14.8,3.1-18.6,8.5V41.8h-10.3V127.4z M259.7,93.5h20.2v19c-6.2,5.4-15.6,7.5-23.2,7.5c-19,0-29.8-12.3-29.8-33.9 c0-22.9,11.6-35.6,29.6-35.6c10.7,0,18.7,3.8,26.3,11l6.7-7.6c-6.8-7.5-18.5-13-31.8-13c-26.8,0-42.7,18.7-42.7,44.9 c0,25.7,13.2,43.5,41.9,43.5c15.8,0,28.1-6.9,34.2-13.5v-31h-31.3v8.7H259.7z M641.6,69.1c-18.8,0-28.7,13-28.7,30.1 c0,17.7,9.8,29.4,27.4,29.4c17.5,0,28.4-11.5,28.4-29.7C668.7,80.2,658.6,69.1,641.6,69.1L641.6,69.1z M831.2,69.1 c-18.9,0-28.7,13-28.7,30.1c0,17.7,9.8,29.4,27.4,29.4c17.5,0,28.4-11.5,28.4-29.7C858.3,80.2,848.2,69.1,831.2,69.1L831.2,69.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.6221,
    y1: 118.1871,
    x2: -1.3007,
    y2: 109.6613,
    gradientTransform: "matrix(1 0 0 -1 0 179.2557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1185,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    style: {
      stopColor: "#684795"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5492,
    style: {
      stopColor: "#836AA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7459,
    style: {
      stopColor: "#947FB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    style: {
      stopColor: "#9A87B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C76AF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.1,52.3c13.4,4.3,24,14.2,31.2,28.4c1,1.9,1.5,4.7,0.9,6.4c0.2-0.7,0.5-1.3,0.7-2 c17.2-54-43.7-90.3-74.6-74c-0.6,0.3-1.2,0.6-1.8,1C1.8,35.7-11.6,86.8,11,126.9C-5.2,96,31,35.1,85.1,52.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.1297,
    y1: 282.1645,
    x2: 249.152,
    y2: 273.635,
    gradientTransform: "matrix(0 -1 -1 0 343.0851 420.7028)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1185,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    style: {
      stopColor: "#684795"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5492,
    style: {
      stopColor: "#836AA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7459,
    style: {
      stopColor: "#947FB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    style: {
      stopColor: "#9A87B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C76AF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.3,85.1c4.3-13.4,14.2-24,28.4-31.2c1.9-1,4.7-1.5,6.4-0.9c-0.7-0.2-1.3-0.5-2-0.7 C31.1,35.1-5.2,96,11,126.9c0.3,0.6,0.6,1.2,1,1.8c23.7,39.8,74.7,53.2,114.8,30.5C96,175.4,35.1,139.1,52.3,85.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.0258,
    y1: 31.6517,
    x2: 413.0481,
    y2: 23.1221,
    gradientTransform: "matrix(-1 0 0 1 584.5327 77.6172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1185,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    style: {
      stopColor: "#684795"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5492,
    style: {
      stopColor: "#836AA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7459,
    style: {
      stopColor: "#947FB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    style: {
      stopColor: "#9A87B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C76AF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.1,117.9c-13.4-4.3-24-14.2-31.2-28.4c-1-1.9-1.5-4.7-0.9-6.4c-0.2,0.7-0.5,1.3-0.7,2 c-17.2,54,43.7,90.3,74.6,74.1c0.6-0.3,1.2-0.6,1.8-1c39.8-23.7,53.2-74.7,30.5-114.8C175.3,74.2,139.1,135.1,85.1,117.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.5182,
    y1: -132.3263,
    x2: 162.5336,
    y2: -140.8563,
    gradientTransform: "matrix(0 1 1 0 241.4471 -163.8299)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1185,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    style: {
      stopColor: "#4F2683"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    style: {
      stopColor: "#684795"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5492,
    style: {
      stopColor: "#836AA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7459,
    style: {
      stopColor: "#947FB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    style: {
      stopColor: "#9A87B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C76AF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.9,85.1c-4.3,13.4-14.2,24-28.4,31.2c-1.9,1-4.7,1.5-6.4,0.9c0.7,0.2,1.3,0.5,2,0.7 c54,17.2,90.3-43.7,74-74.6c-0.3-0.6-0.6-1.2-1-1.8C134.4,1.7,83.4-11.7,43.3,11C74.2-5.2,135.1,31.1,117.9,85.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtLogo);
export default __webpack_public_path__ + "static/media/gt_logo.3c7aa07cd2178eae56316258b0f8f549.svg";
export { ForwardRef as ReactComponent };